import VueI18n from 'vue-i18n';
import Vue from 'vue';
import zh from '../api/languages/zh-cn';
import en from '../api/languages/en-us';
import store from '../store';
import router from '../router'
import  { getUrlKey } from './utils'
Vue.use(VueI18n);
let querylang = getUrlKey('lang',window.location.href)
let lang = navigator.language||navigator.userLanguage;//常规浏览器语言和IE浏览器
lang = lang.substr(0, 2);
let defaultLang  = null;
if(querylang == 'auto'){
	defaultLang = lang;
}else{
  defaultLang = JSON.parse(localStorage.getItem('locale')) || lang;
};
console.log(defaultLang)
store.commit('setLocale',defaultLang)
const i18n = new VueI18n({
// 设置默认语言
  locale: defaultLang, //语言标识
  messages: {
    zh,
    en
  }
})
export default i18n